import { InputAdornment } from "@mui/material";
import { CoreSelect } from "../../core";
import Funnel from "../images/funnel.svg?react";
import styles from "./EditQuizFilter.module.css";

export const EDIT_QUIZ_FILTER_TYPE = ["all", "selected", "notSelected"] as const;
export type EditQuizFilterType = (typeof EDIT_QUIZ_FILTER_TYPE)[number];

type EditQuizFilterProps<T extends string> = {
	value: T;
	onChange: (selected: T) => void;
	renderValue: (value: T) => React.ReactNode;
	children: React.ReactNode;
	ariaLabel: string;
	minWidth?: number;
};

// UI team wants a filter that looks like a Select
export default function EditQuizFilter<T extends string>({
	children,
	onChange,
	renderValue,
	value,
	ariaLabel,
	minWidth,
}: EditQuizFilterProps<T>) {
	return (
		<CoreSelect<T>
			aria-label={ariaLabel}
			value={value}
			onChange={(e) => onChange(e.target.value as T)}
			renderValue={renderValue}
			startAdornment={
				<InputAdornment position="start">
					<Funnel />
				</InputAdornment>
			}
			className={styles.editQuizFilter}
			sx={minWidth ? { minWidth } : undefined}
			MenuProps={minWidth ? { slotProps: { paper: { style: { minWidth } } } } : undefined}
		>
			{children}
		</CoreSelect>
	);
}
